<template>
  <DBox
    :id="'cmp-booking-template-code-editor-'+name"
    :addButton="false"
    :addLink="false"
    :rightMenu="[
      {
        text: $t('save_btn'),
        value: 'save',
      }
    ]"
    @menuClick="onRightMenuClick"
  >
    
      <textarea
        class="template-body-text ut-h-full"
        :value="value"
        ref="body_text"
        style="padding-left: 10px; padding-top: 5px; resize: none;"
      >
      </textarea>
    
  </DBox>
</template>

<script>
export default {
  props: ["name", "value"],
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    onRightMenuClick(menu) {
      switch (menu) {
        case "save":
          this.$emit('save', this.$refs["body_text"].value);
          break;
      
        default:
          break;
      }
    },
  },
};
</script>
